const fontStack =
  "'SF Normal', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const sectionHeadingStyle = {
  fontFamily: fontStack,
  fontWeight: 800,
  textAlign: "left",
  fontSize: "clamp(2.2rem, 5vw, 5rem)",
  lineHeight: 0.95,
  color: "#181716",
  margin: 0,
  width: "100%",
};

export const sectionContainerStyle = {
  minHeight: "100vh",
  width: "100%",
  padding: "clamp(88px, 8vw, 128px) clamp(20px, 7vw, 104px)",
  backgroundColor: "transparent",
  textAlign: "left",
};

export const itemHeading = {
  fontFamily: fontStack,
  textAlign: "left",
  fontSize: "clamp(1.08rem, 1.4vw, 1.35rem)",
  fontWeight: 800,
  color: "#181716",
  lineHeight: 1.2,
  margin: 0,
};

export const itemDesSmall = {
  fontFamily: fontStack,
  fontWeight: 700,
  textAlign: "left",
  fontSize: "0.86rem",
  color: "#0f766e",
  lineHeight: 1.4,
  margin: "8px 0",
};

export const headingStyle = {
  fontFamily: fontStack,
  fontSize: "clamp(2.5rem, 5.4vw, 5rem)",
  fontWeight: 900,
  color: "#181716",
  lineHeight: 0.98,
  margin: 0,
  textAlign: "left",
};

export const bioStyle = {
  fontFamily: fontStack,
  color: "#67615a",
  textAlign: "left",
  width: "100%",
  maxWidth: "min(100%, 1040px)",
  margin: "18px 0 0",
};

export const descriptionStyle = {
  fontFamily: fontStack,
  padding: 0,
  margin: 0,
  textAlign: "left",
  fontSize: "1rem",
  color: "#67615a",
  lineHeight: 1.6,
};

export const pageStyle = {
  width: "100%",
  textAlign: "left",
  paddingLeft: "8vw",
  paddingRight: "8vw",
  fontSize: "1rem",
  color: "#181716",
  lineHeight: 1.6,
};

export const headingContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "20px",
  width: "100%",
  maxWidth: "1120px",
  marginBottom: "24px",
};

export const containerStyle = {
  padding: "22px",
  marginBottom: "14px",
  background: "rgba(255, 255, 255, 0.76)",
  borderRadius: "16px",
  border: "1px solid rgba(24, 23, 22, 0.1)",
  boxShadow: "0 12px 30px rgba(40, 36, 30, 0.08)",
};
